import { render, staticRenderFns } from "./template.vue?vue&type=template&id=5cfd52dc&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=5cfd52dc&scoped=true&lang=css&"
import style1 from "./template.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd52dc",
  null
  
)

export default component.exports